// Vendors
import { ParagraphComponent } from '@openbank/ziniaweb-ui-components';
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Constants
import { CANCEL_DROP_MODAL_DESCRIPTION_MODAL_PROPS } from './constants/cancel-drop-modal-description.constants';
// Styles
import { CancelDropModalDescriptionComponentStyled } from './cancel-drop-modal-description.component.styled';
// Types
import { CancelDropModalComponentType } from 'components/cancel-drop-modal/types/cancel-drop-modal.component.type';

const CancelDropModalDescriptionComponent = ({
  description,
}: Pick<CancelDropModalComponentType, 'description'>): React.JSX.Element => (
  <CancelDropModalDescriptionComponentStyled>
    <ParagraphComponent {...CANCEL_DROP_MODAL_DESCRIPTION_MODAL_PROPS}>
      <FormattedMessage id={description} />
    </ParagraphComponent>
  </CancelDropModalDescriptionComponentStyled>
);

export { CancelDropModalDescriptionComponent };
